import { sendToZCM } from '@/models/globalServices';
import { history } from '@umijs/max';
import { Modal, notification } from 'antd';
import dayjs from 'dayjs';

export const downloadBlob = async (res: any, type: any, suffix: any) => {
  const result = await new Blob([res], {
    type: 'application/json',
  }).text();
  const currentUserType = localStorage.getItem('currentUserType') || 'user';
  if (
    typeof result === 'string' &&
    result.includes('message') &&
    result.includes('code')
  ) {
    // 因为返回的是UTF-8 格式的 USVString需要手动转一下string
    const responseData = JSON.parse(String(result));
    if (result.includes('S-SYS-00027')) {
      history.push(`/login/${currentUserType}`);
    }
    return notification.error({
      message: 'Error',
      description: responseData?.message,
    });
  }
  let blod = new Blob([res], {
    type,
  });
  let obj = URL.createObjectURL(blod);
  let a = document.createElement('a');
  a.href = obj;
  a.download = suffix;
  a.click();
  URL.revokeObjectURL(obj);
};

export const batchSuccessModal = (message: string) => {
  Modal.success({
    content: message,
    footer: null,
    closable: true,
  });
};

// 精度转换方法
export const transferPrecision: any = (price: any, precision: any = 10000) =>
  Math.abs(parseInt(price, 10) / parseInt(precision, 10)).toFixed(2);

// 图表精度转换
// export const chartPrecision: any = (price: any, chartPrecision: any) =>
//   (parseInt(price, 10) / 10 ** parseInt(chartPrecision, 10)).toFixed(2);

// 图表精度转换
export const chartPrecision: any = (price: any, chartPrecision: any) => {
  // 检查输入值是否为null或者是NaN，如果是，将其转换为数字0
  const validPrice =
    price === null || Number.isNaN(Number(price)) ? 0 : parseInt(price, 10);

  const validChartPrecision = parseInt(chartPrecision, 10);

  // 使用有效的数字进行计算，先将价格转换为整数再进行计算
  const result = Math.abs(validPrice) / 10 ** validChartPrecision;

  // 返回结果，限定小数点后两位
  return result.toFixed(2);
};

// 单位常量
export const RM = 'RM';

// 使用正则表达式为整数部分每三位添加逗号 (该方法使用正则表达式re来查找匹配项，并用 '$1,' 替换它们)
export const transferAmountRegex = (value: any) => {
  const regx = /(\d)(?=(\d{3})+(?!\d))/g;
  return value.replace(regx, '$1,');
};

// 处理blob类型转换为json
export const blobToJson = (blob: Blob) => {
  return blob?.text().then((text: string) => JSON.parse(text));
};

// 处理BCARE_MEMBER_SERV_TYPE配置项格式，取key值集合返回
export const getCommonServTypeKey = (data: string | undefined | null) => {
  const servTypes = data?.split(',');
  // 提取每个部分的数字并生成新数组
  const servTypeNumbers = servTypes?.map((item: any) => item.split(':')[0]);
  const result = servTypeNumbers?.join(',');
  return result;
};

// um下载支付收据格式 ddmmyyyyHHMISS
export const getPaymentReceiptPDFName = () => {
  const currentDate = new Date();
  const dd = String(currentDate.getDate()).padStart(2, '0');
  const mm = String(currentDate.getMonth() + 1).padStart(2, '0');
  const yyyy = currentDate.getFullYear();
  const HH = String(currentDate.getHours()).padStart(2, '0');
  const MI = String(currentDate.getMinutes()).padStart(2, '0');
  const SS = String(currentDate.getSeconds()).padStart(2, '0');

  const currentDateTime = `${dd}${mm}${yyyy}${HH}${MI}${SS}`;
  return currentDateTime;
};

// 校验表单字段规则
export const commonFormValidate = (
  value: string,
  maxLength: number,
  formatMessage: any,
) => {
  if (value?.length > maxLength) {
    return Promise.reject(
      new Error(formatMessage('common.lengthValid', { length: maxLength })),
    );
  }
  return Promise.resolve();
};

let isSending = false;
export const sendDataToZCM = async (n: number) => {
  if (isSending) return;

  isSending = true;
  // 创建独立的暂存数组
  const tempStorageHttp = [];
  const tempStorageNgportal = [];

  // 计算需要保留的数量
  let remaining = n;

  // 处理 front_log_http
  if (window.dataToZCM.data.front_log_http.length > remaining) {
    // 超过的部分暂存起来
    tempStorageHttp.push(
      ...window.dataToZCM.data.front_log_http.slice(remaining),
    );
    // 只保留前 remaining 条
    window.dataToZCM.data.front_log_http =
      window.dataToZCM.data.front_log_http.slice(0, remaining);
    remaining = 0; // 已经达到需要保留的数量
  } else {
    // 如果 front_log_http 不足，全部保留
    remaining -= window.dataToZCM.data.front_log_http.length;
  }

  // 处理 front_log_ngportal
  if (remaining > 0) {
    if (window.dataToZCM.data.front_log_ngportal.length > remaining) {
      // 超过的部分暂存起来
      tempStorageNgportal.push(
        ...window.dataToZCM.data.front_log_ngportal.slice(remaining),
      );
      // 只保留前 remaining 条
      window.dataToZCM.data.front_log_ngportal =
        window.dataToZCM.data.front_log_ngportal.slice(0, remaining);
    }
  } else {
    // 如果不需要从 ngportal 保留任何数据，全部暂存
    tempStorageNgportal.push(...window.dataToZCM.data.front_log_ngportal);
    window.dataToZCM.data.front_log_ngportal = [];
  }

  try {
    // 调用接口后清空两个数组
    const data = JSON.parse(JSON.stringify(window.dataToZCM));

    const { resultCode } = await sendToZCM(JSON.stringify(data));
    if (resultCode === '200') {
      // 清空数组
      window.dataToZCM.data.front_log_http = [];
      window.dataToZCM.data.front_log_ngportal = [];

      // 将暂存的数据放回各自的数组中
      window.dataToZCM.data.front_log_http.push(...tempStorageHttp);
      window.dataToZCM.data.front_log_ngportal.push(...tempStorageNgportal);
    }
  } finally {
    isSending = false;
  }
};

// 将字符串格式日期转化成15 October 2024, 11:30 AM - 2:00 PM格式
export const formatDateRangeSimple = (start: any, end: any) => {
  if (!start && !end) {
    return '-';
  }

  const startDate = dayjs(
    start,
    ['D/M/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm:ss', 'YYYY-MM-DD HH:mm:ss'],
    true,
  );
  const endDate = dayjs(
    end,
    ['D/M/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm:ss', 'YYYY-MM-DD HH:mm:ss'],
    true,
  );

  const formattedDate = startDate.format('D MMMM YYYY'); // 15 October 2024
  const formattedStartTime = startDate.format('h:mm A'); // 11:30 AM
  const formattedEndTime = endDate.format('h:mm A'); // 2:00 PM

  return `${formattedDate}, ${formattedStartTime} - ${formattedEndTime}`;
};
